<div class="vf-contrib-stack" *ngIf="contributors?.length > 0">
  <div class="vf-contrib-stack-avatars" [class.vf-contrib-stack-avatars--sm]="size === 'sm'">
    <div
      *ngFor="let contributor of visibleContributors; let idx = index"
      class="vf-contrib-stack-avatar"
      [class.vf-contrib-stack-avatar--sm]="size === 'sm'"
      [style.marginLeft.px]="idx === 0 ? 0 : -5"
      [title]="getName(contributor)">
      <img *ngIf="contributor.profilePictureUrl" [src]="contributor.profilePictureUrl" [alt]="getName(contributor)" class="vf-contrib-stack-avatar-img">
      <span *ngIf="!contributor.profilePictureUrl" class="vf-contrib-stack-avatar-initials">{{getInitials(contributor)}}</span>
    </div>
  </div>
  <span *ngIf="showFirstName" class="vf-contrib-stack-name">{{firstName}}</span>
  <span *ngIf="overflowCount > 0" class="vf-contrib-stack-overflow">+{{overflowCount}}</span>
  <div class="vf-contrib-stack-popover">
    <div class="vf-contrib-stack-popover-header">CONTRIBUTORS &middot; {{contributors.length}}</div>
    <div class="vf-contrib-stack-popover-list">
      <div *ngFor="let contributor of contributors" class="vf-contrib-stack-popover-item">
        <div class="vf-contrib-stack-avatar vf-contrib-stack-avatar--sm">
          <img *ngIf="contributor.profilePictureUrl" [src]="contributor.profilePictureUrl" [alt]="getName(contributor)" class="vf-contrib-stack-avatar-img">
          <span *ngIf="!contributor.profilePictureUrl" class="vf-contrib-stack-avatar-initials">{{getInitials(contributor)}}</span>
        </div>
        <span class="vf-contrib-stack-popover-name">{{getName(contributor)}}</span>
      </div>
    </div>
  </div>
</div>

<span *ngIf="!contributors?.length && emptyLabel" class="vf-contrib-stack-empty">{{emptyLabel}}</span>

<style>
.vf-contrib-stack {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
  cursor: default;
}
.vf-contrib-stack-avatars {
  display: flex;
  align-items: center;
}
.vf-contrib-stack-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 0 0 1px #ffffff;
}
.vf-contrib-stack-avatar--sm {
  width: 16px;
  height: 16px;
  font-size: 9px;
}
.vf-contrib-stack-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.vf-contrib-stack-name {
  font-size: 13px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}
.vf-contrib-stack-overflow {
  font-size: 11px;
  color: #9ca3af;
  flex-shrink: 0;
}
.vf-contrib-stack-empty {
  font-size: 12px;
  color: #9ca3af;
}
.vf-contrib-stack-popover {
  pointer-events: none;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  z-index: 300;
  opacity: 0;
  transition: opacity 0.15s;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  min-width: 180px;
}
.vf-contrib-stack:hover .vf-contrib-stack-popover {
  opacity: 1;
  pointer-events: auto;
}
.vf-contrib-stack-popover-header {
  padding: 10px 12px 6px 12px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 11px;
  color: #9ca3af;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.vf-contrib-stack-popover-list {
  padding: 6px 0;
  max-height: 220px;
  overflow-y: auto;
}
.vf-contrib-stack-popover-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
}
.vf-contrib-stack-popover-name {
  font-size: 12px;
  color: #374151;
  font-weight: 500;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
